// extracted by css-extract-rspack-plugin
export default {"cls1":"SimpleResultsView-cls1_1Bj","cls2":"SimpleResultsView-cls2_oZa SimpleResultsView-cls1_1Bj"};